import React, { useEffect, useState } from 'react';
export function CountdownTimer() {
  const [time, setTime] = useState({
    hours: 1,
    minutes: 32,
    seconds: 12
  });
  useEffect(() => {
    const interval = setInterval(() => {
      setTime(prev => {
        let {
          hours,
          minutes,
          seconds
        } = prev;
        if (seconds > 0) seconds--;else if (minutes > 0) {
          minutes--;
          seconds = 59;
        } else if (hours > 0) {
          hours--;
          minutes = 59;
          seconds = 59;
        }
        return {
          hours,
          minutes,
          seconds
        };
      });
    }, 1000);
    return () => clearInterval(interval);
  }, []);
  const pad = (n: number) => String(n).padStart(2, '0');
  return <div className="grid grid-cols-3 gap-3 max-w-sm mx-auto" data-id="element-61">
      {[{
      label: 'Hours',
      value: pad(time.hours)
    }, {
      label: 'Minutes',
      value: pad(time.minutes)
    }, {
      label: 'Seconds',
      value: pad(time.seconds)
    }].map((unit, idx) => <div key={idx} className="bg-pilates-blue-dark text-white rounded-md py-3 px-2 text-center shadow-md border-t-2 border-pilates-lavender" data-id="element-62">
          <div className="font-display text-3xl sm:text-4xl font-semibold text-white leading-none" data-id="element-63">
            {unit.value}
          </div>
          <div className="text-[10px] sm:text-xs uppercase tracking-wider text-pilates-lavender mt-1 font-medium" data-id="element-64">
            {unit.label}
          </div>
        </div>)}
    </div>;
}